export function isTouchDevice(): boolean {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || (navigator as any)?.msMaxTouchPoints > 0;
}